// extracted by mini-css-extract-plugin
export default {"wrapper":"UserMenu_wrapper__YvbMI","username":"UserMenu_username__1FENz","link":"UserMenu_link__d6eY9"};